import './index.js'; // 🎯 Vite leerá esto en desarrollo y unificará app.js dentro del dist final




(async function boot() {
  console.log("🚀 Boot index web_general");
  console.log("✅ Todos los módulos han sido unificados y cargados por Vite");
})();